import { administrationRequests } from "api/administrationApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import { NationalityType } from "utils/choices";

const SummaryOfStudentCountsByStatus = ({ handleParamChange }) => {
  const { setValue } = useFormContext();
  const structuralUnitId = useWatch({ name: "structuralUnitId" });

  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onChange={() => setValue("specialityId", null)}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      {structuralUnitId && (
        <ReferenceInput
          source="specialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
          filter={{ structuralUnitId }}
        >
          <AutoPickSelectInput
            source="specialityId"
            label="Специалност"
            optionText="name"
            optionValue="id"
            validate={[required()]}
            emptyText={false}
            onValueChange={v => handleParamChange("specialityId", v)}
          />
        </ReferenceInput>
      )}
      <ReferenceInput
        source="studyTypeId"
        reference={administrationRequests.getStudyTypesSelect()}
      >
        <SelectInput
          label="Форма на обучение"
          validate={required()}
          emptyText={false}
          onChange={e => handleParamChange("studyTypeId", e.target.value)}
        />
      </ReferenceInput>
      <ReferenceInput
        source="instructionLanguageId"
        reference={administrationRequests.getInstructionLanguagesSelect()}
      >
        <SelectInput
          label="Език на обучение"
          onChange={e => handleParamChange("instructionLanguageId", e.target.value)}
        />
      </ReferenceInput>
      <SelectInput
        choices={NationalityType}
        source="nationalityType"
        label="Националност"
        onChange={e => handleParamChange("nationalityType", e.target.value)}
      />
    </>
  );
};

export default SummaryOfStudentCountsByStatus;
